import { ApiCall } from '@lcms/api-definition';
import { AzureUser } from '@lcms/identity-microsoft';
import { ImplicitLoginResult } from '@lcms/react-identity/lib/context/configuration/database-login';
import { endpoints } from '../../endpoints';

export type EndpointResponse = ImplicitLoginResult<AzureUser, AzureUser>
export const loginEndpoint = new ApiCall<EndpointResponse>().get('login', { route: endpoints.login });